"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleFn = void 0;
/**
 * Executes the latest call of a function in a given time window
 */
function sampleFn(callback, interval) {
    let sampleTimer;
    let latestArgs;
    function dispatch() {
        if (latestArgs)
            callback(...latestArgs);
        sampleTimer = undefined;
    }
    return {
        sampled: function sampledFn(...args) {
            if (sampleTimer == null) {
                sampleTimer = window.setTimeout(dispatch, interval);
            }
            latestArgs = args;
        },
        cancel: () => {
            clearTimeout(sampleTimer);
            sampleTimer = undefined;
        },
    };
}
exports.sampleFn = sampleFn;
